import { render } from "./doctor-detail.vue?vue&type=template&id=38ebcf94&scoped=true"
import script from "./doctor-detail.vue?vue&type=script&lang=js"
export * from "./doctor-detail.vue?vue&type=script&lang=js"

import "./doctor-detail.vue?vue&type=style&index=0&id=38ebcf94&scoped=true&lang=css"

import exportComponent from "/studio/gordon/Studio/mylink-intgr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ebcf94"]])

export default __exports__